export function useFormUrl(): string {
  return 'https://readdy.ai/api/form/d9slsq5lbrt1qcgaj5sg';
}